export const PredefinedWord = {
    Roles: {
        ADMIN: "Admin",
        USER: "User",
        DENTIST: "dentist",
        CENTRAL_HUB: "central hub",
        MILLING_HUB: "milling hub",
        CENTRAL: {
            MANAGER: "manager",
            DESIGNER: "designer"
        },
        DELIVERYPARTNER:"delivery"
        
        
    },
    images: {
        rightbgimage: "/rightbgimage.png",
        rightbgimagealt: "Dental",

        profile: "/profile.png",
        profilealt: "User Profile",
    }
};
